/**
 * The dossier checklist's declaration lines on the domain page ("Hồ sơ & định danh"): "the
 * registrant's declaration exists" and "it is signed". Only the registration form (Mẫu 01a / 01b /
 * 01c) of the domain's holder counts — generated for the domain's current subject, or from the
 * subject version its dossier pins. A return form (Mẫu 03), a parental consent (Mẫu 02) or another
 * subject's form that names the domain meets neither line (review #4 / #21).
 *
 * Pure functions (no React): `npm test` covers them.
 */

import type { Declaration } from '../api/areas/declarations';

/** Whose declarations are the domain's: its current subject and the version its dossier pins. */
export interface DeclarationHolder {
  currentSubjectId: string | null;
  pinnedVersionId: string | null;
}

type Row = Pick<Declaration, 'subject_id' | 'subject_version_id' | 'purpose' | 'status'>;

/** The holder's registration forms among `list`. */
export function holderRegistrationForms<T extends Row>(list: readonly T[], holder: DeclarationHolder): T[] {
  return list.filter(
    (d) =>
      (d.purpose ?? 'REGISTRATION') === 'REGISTRATION' &&
      ((holder.currentSubjectId !== null && d.subject_id === holder.currentSubjectId) || (holder.pinnedVersionId !== null && d.subject_version_id === holder.pinnedVersionId)),
  );
}

/** `null` while the declarations are not loaded. */
export function declarationChecks(list: readonly Row[] | null, holder: DeclarationHolder): { declared: boolean | null; signed: boolean | null } {
  if (list === null) return { declared: null, signed: null };
  const own = holderRegistrationForms(list, holder);
  return { declared: own.length > 0, signed: own.some((d) => d.status === 'VERIFIED' || d.status === 'APPROVED') };
}
